<template>
<div>
    <b-row v-touch:swipe.left="nextPage" v-touch:swipe.right="previousPage" :class="{'d-flex': true, 'justify-content-center': true, 'my-5': !showingInForm, 'my-4': showingInForm}">
        <b-col class="arrow-container" cols="1"><b-icon-caret-left scale="1.4" class="arrow-left-predefined" v-if="!$store.state.healthyHabits.predefinedHabit.hideLeftArrow" @click="previousPage"></b-icon-caret-left></b-col>
        <b-col class="d-flex justify-content-center" cols="5" :sm="showingInForm ? 5 : 3" :md="showingInForm ? 3 : 5" xl="3" v-for="(item, index) in itemsToShow" :key="`habit-predefined-${index}`">
            <base-card @click="predefinedHabitSelected(item)" :style="{'z-index': boxPredefinedZIndex(index)}" :class="{'card-predefined': true, 'predefined-selected': item.id === $store.state.healthyHabits.predefinedHabit.itemIdSelected}"><span class="card-predefined-description">{{item.description}}</span></base-card>
        </b-col>
        <b-col class="arrow-container" cols="1"><b-icon-caret-right scale="1.4" class="arrow-right-predefined" v-if="!$store.state.healthyHabits.predefinedHabit.hideRightArrow" @click="nextPage"></b-icon-caret-right></b-col>
    </b-row>
</div>
</template>
<script>
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'
import BaseCard from '@/components/base/ui/BaseCard'
import BaseModal from '@/components/base/BaseModal'
import helpers from '@/helpers'
import '@/plugins/vue-touch'
import { BRow, BCol, BIcon } from 'bootstrap-vue'

export default {
   name: 'healthyHabitsPredefined',
   components: {
    BaseCard,
    BaseModal,
    BRow,
    BCol,
    BIcon
   },
   props: {
    showingInForm: Boolean
   },
   created () {
    this.$store.state.healthyHabits.predefinedHabit.startIndex = this.$store.state.healthyHabits.form.predefinedHabit && this.$store.state.healthyHabits.predefinedHabit.startIndex ? this.$store.state.healthyHabits.predefinedHabit.startIndex : 0
    this.$store.state.healthyHabits.predefinedHabit.endIndex = this.$store.state.healthyHabits.form.predefinedHabit && this.$store.state.healthyHabits.predefinedHabit.endIndex ? this.$store.state.healthyHabits.predefinedHabit.endIndex : this.itemsPerPage
    this.itemsToShow = this.data.slice(this.$store.state.healthyHabits.predefinedHabit.startIndex, this.$store.state.healthyHabits.predefinedHabit.endIndex)
    this.$store.state.healthyHabits.predefinedHabit.hideLeftArrow = this.$store.state.healthyHabits.predefinedHabit.startIndex === 0 ? true : this.$store.state.healthyHabits.predefinedHabit.hideLeftArrow
    this.$store.state.healthyHabits.predefinedHabit.hideRightArrow = this.$store.state.healthyHabits.predefinedHabit.endIndex === this.data.length ? true : this.$store.state.healthyHabits.predefinedHabit.hideRighArrow
   },
   mixins: [healthyHabitsMixin],
   data () {
    return {
        itemsToShow: [],
        data: [
            { id: helpers.generateGuid(), description: this.$t('predefined-walk'), question: this.$t('predefined-walk-question'), measurable: true, goalFrequencyId: 1, measureUnit: 'Km' },
            { id: helpers.generateGuid(), description: this.$t('predefined-more-time-in-family'), question: this.$t('predefined-more-time-in-family-question'), measurable: false, goal: 1, goalFrequencyId: 1 },
            { id: helpers.generateGuid(), description: this.$t('predefined-lose-weight'), question: this.$t('predefined-lose-weight-question'), measurable: true, goalFrequencyId: 2, measureUnit: 'Kg' },
            { id: helpers.generateGuid(), description: this.$t('predefined-sleep-better'), question: this.$t('predefined-sleep-better-question'), measurable: false, goal: 1, goalFrequencyId: 1 },
            { id: helpers.generateGuid(), description: this.$t('predefined-week-exercise'), question: this.$t('predefined-week-exercise-question'), measurable: false, goal: 6, goalFrequencyId: 2 },
            { id: helpers.generateGuid(), description: this.$t('predefined-ultra-processed-foods'), question: this.$t('predefined-ultra-processed-foods-question'), measurable: false, goal: 1, goalFrequencyId: 1 },
            { id: helpers.generateGuid(), description: this.$t('predefined-run'), question: this.$t('predefined-run-question'), measurable: true, goalFrequencyId: 1, measureUnit: 'Km' },
            { id: helpers.generateGuid(), description: this.$t('predefined-bike'), question: this.$t('predefined-bike-question'), measurable: true, goalFrequencyId: 2, measureUnit: 'Km' },
            { id: helpers.generateGuid(), description: this.$t('predefined-swim'), question: this.$t('predefined-swim-question'), measurable: true, goalFrequencyId: 2, measureUnit: this.$t('meters') },
            { id: helpers.generateGuid(), description: this.$t('predefined-read'), question: this.$t('predefined-read-question'), measurable: true, goalFrequencyId: 1, measureUnit: this.$t('pagesHabit') },
            { id: helpers.generateGuid(), description: this.$t('predefined-argue-less'), question: this.$t('predefined-argue-less-question'), measurable: false, goal: 1, goalFrequencyId: 2 },
            { id: helpers.generateGuid(), description: this.$t('predefined-meditation'), question: this.$t('predefined-meditation-question'), measurable: false, goal: 3, goalFrequencyId: 2 },
            { id: helpers.generateGuid(), description: this.$t('predefined-drink-water'), question: this.$t('predefined-drink-water-question'), measurable: true, goalFrequencyId: 1, measureUnit: this.$t('liters') },
            { id: helpers.generateGuid(), description: this.$t('predefined-smoke'), question: this.$t('predefined-smoke-question'), measurable: false, goal: 1, goalFrequencyId: 1 },
            { id: helpers.generateGuid(), description: this.$t('predefined-go-gym'), question: this.$t('predefined-go-gym-question'), measurable: false, goal: 3, goalFrequencyId: 2 },
            { id: helpers.generateGuid(), description: this.$t('predefined-drink-alcohol'), question: this.$t('predefined-drink-alcohol-question'), measurable: false, goal: 1, goalFrequencyId: 1 }
        ]
    }
   },
   computed: {
    itemsPerPage () {
        return window.innerWidth >= 1200 ? 3 : window.innerWidth >= 768 ? (this.showingInForm ? 3 : 2) : window.innerWidth < 576 ? 2 : (this.showingInForm ? 2 : 3)
    }
   },
   methods: {
    predefinedHabitSelected (item) {
        this.$store.state.healthyHabits.form.predefinedHabit = item
        this.$store.state.healthyHabits.predefinedHabit.itemIdSelected = item.id
        this.$store.state.healthyHabits.form.show = true
        this.$emit('predefinedHabitSelected')
    },
    previousPage () {
        if (this.$store.state.healthyHabits.predefinedHabit.startIndex === 0) {
            return
        }
        this.itemsToShow = this.data.slice(this.$store.state.healthyHabits.predefinedHabit.startIndex - this.itemsPerPage, this.$store.state.healthyHabits.predefinedHabit.startIndex)
        this.$store.state.healthyHabits.predefinedHabit.endIndex = this.$store.state.healthyHabits.predefinedHabit.startIndex
        this.$store.state.healthyHabits.predefinedHabit.startIndex -= this.itemsPerPage
        if (this.$store.state.healthyHabits.predefinedHabit.startIndex <= 0) {
            this.$store.state.healthyHabits.predefinedHabit.hideLeftArrow = true
            this.$store.state.healthyHabits.predefinedHabit.startIndex = 0
        }
        this.$store.state.healthyHabits.predefinedHabit.hideRightArrow = false
    },
    nextPage () {
        if (this.$store.state.healthyHabits.predefinedHabit.endIndex === this.data.length) {
            return
        }
        this.itemsToShow = this.data.slice(this.$store.state.healthyHabits.predefinedHabit.endIndex, this.$store.state.healthyHabits.predefinedHabit.endIndex + this.itemsPerPage)
        this.$store.state.healthyHabits.predefinedHabit.startIndex = this.$store.state.healthyHabits.predefinedHabit.endIndex
        this.$store.state.healthyHabits.predefinedHabit.endIndex = this.$store.state.healthyHabits.predefinedHabit.startIndex + this.itemsPerPage
        if (this.$store.state.healthyHabits.predefinedHabit.endIndex >= this.data.length) {
            this.$store.state.healthyHabits.predefinedHabit.hideRightArrow = true
            this.$store.state.healthyHabits.predefinedHabit.endIndex = this.data.length
        }
        this.$store.state.healthyHabits.predefinedHabit.hideLeftArrow = false
    },
    boxPredefinedZIndex (index) {
        return (this.itemsPerPage === 2 && index === 0) || (this.itemsPerPage === 3 && index === 1) ? 1 : this.itemsPerPage === 3 && index === 0 ? 2 : 'auto'
    }
   }
}
</script>
<style lang="scss">
.card-predefined{
    cursor: pointer;
    text-align: center;
    color: $blue;
    display: table;
}
.arrow-left-predefined{
  color: $gray-600;
  cursor: pointer;
  position: absolute;
  right: 20%;
  top: 50%;
}
.arrow-right-predefined{
  color: $gray-600;
  cursor: pointer;
  position: absolute;
  left: 20%;
  top: 50%;
}
.arrow-container{
    max-width: 20px;
}
.card-predefined-description{
    display: table-cell;
    width: 65.5px;
    height: 45px;
    min-width: 60px;
    min-height: 45px;
    vertical-align: middle;
    @media screen and (max-width: 374px) {
        width: auto;
        // min-width: auto;
        max-width: 41px;
    }
}
.predefined-selected {
    background-color: $blue;
    color: white;
    border: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabitsPredefined.vue